import autenticarService from '@/servicios/autenticar'
import { ERROR_OBTIENE_TOKEN_AUTENTICACION } from '@/utilidades/errores'

export const ObtieneTokenAutenticacionMixin = {
  data: () => ({
    consumiendoTokenAutenticacion: false,
  }),
  methods: {
    // Metodos publicos
    obtieneTokenAutenticacion() {
      this.$_ObtieneTokenAutenticacionMixin_IniciaObtieneTokenAutenticacion()
      autenticarService
        .AutenticarV3()
        .then((result) => {
          this.$_ObtieneTokenAutenticacionMixin_TerminaObtieneTokenAutenticacion()
          if (result.status !== 200) {
            this.errorObtieneTokenAutenticacion(
              ERROR_OBTIENE_TOKEN_AUTENTICACION
            )
            return
          }
          const data = result.data
          if (data.Codigo !== 200) {
            this.errorObtieneTokenAutenticacion(data.Mensaje)
            return
          }
          this.postObtieneTokenAutenticacion(data.Modelo)
        })
        .catch((err) => {
          this.$_ObtieneTokenAutenticacionMixin_TerminaObtieneTokenAutenticacion()
          console.error(err)
          this.errorObtieneTokenAutenticacion(ERROR_OBTIENE_TOKEN_AUTENTICACION)
        })
    },
    postObtieneTokenAutenticacion() {},
    errorObtieneTokenAutenticacion(mensaje) {
      console.error(mensaje)
    },

    // Metodos privados
    $_ObtieneTokenAutenticacionMixin_IniciaObtieneTokenAutenticacion() {
      this.consumiendoTokenAutenticacion = true
    },
    $_ObtieneTokenAutenticacionMixin_TerminaObtieneTokenAutenticacion() {
      this.consumiendoTokenAutenticacion = false
    },
  },
}
